module.exports = __webpack_public_path__ + "static/media/mortyIcon.57cb2a8a.png";